import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'signup-open_product_sign_up_modal-click';

/**
 * Logged out user clicks on a product tile and sees the product version of the sign up modal
 */
export function trackSignupOpenProductSignUpModalClick(
  productToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: { productToken },
  });
}
